import { openHome } from '@/services/app/mcd';
import CSS from './HomeButton.module.css';
import HomeIcon from '@/assets/images/home-icon.svg?react';

export const HomeButton = ({ style }: { style?: React.CSSProperties }) => (
  <button onClick={openHome} className={CSS.homeButton} role="button" style={style}>
    <HomeIcon />
  </button>
);
